import React from 'react'
import { convertToJson, getExention } from '../../utils/fileUtil'
import { Button } from '@deere/ux.uxframe-react'
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ExcelJS from "exceljs/dist/exceljs.min"

export const InputFile = ({ setData, setColDefs, loading }) => {
    const hiddenFileInput = React.useRef(null);

    const handleFileChange = event => {
        const fileObj = event.target.files && event.target.files[0];
        if (!fileObj) {
            return;
        }
        const file = fileObj;
        const reader = new FileReader()
        reader.onload = async (event) => {
            const buffer = event.target.result
            const workBook = new ExcelJS.Workbook()
            await workBook.xlsx.load(buffer)
            const workSheet = workBook.worksheets[0]
            const fileData = []
            workSheet.eachRow({ includeEmpty: false }, (row) => {
                fileData.push(row.values.slice(1))
            })
            const headers = fileData[0]
            const heads = headers.map(head => ({ headerName: head, field: head, minWidth: 150, flex: 1 }))
            setColDefs(heads)
            setData(convertToJson(headers, fileData))
            event.target.value = ''
        }
        if (file) {
            if (getExention(file)) {
                reader.readAsArrayBuffer(file)
            }
            else {
                alert("Invalid file input, Select Excel, CSV file")
            }
        } else {
            setData([])
        }
    }

    const handleClick = (event) => {
        hiddenFileInput.current.value = "";
        hiddenFileInput.current.click();
    }

    return (
        <div>
            <input
                style={{ display: 'none' }}
                type="file"
                onChange={handleFileChange}
                ref={hiddenFileInput}
            />
            <Button variant="secondary" startIcon={<UploadFileIcon />} onClick={handleClick} disabled={loading}>
                Import File
            </Button>
        </div>
    )
}